<template>
	<!--底部 start-->
	<div class="footer">
		<div class="main">
			<div class="botInfoBox">
				<div style="display: flex;flex-direction:column">
				<div class="phone ">
					<div class="icon"><i></i></div>
					<div class="phoneNum">
						<h3>全国统一服务热线：</h3>
						<p>400-915-0651 </p>
					</div>
					<div style="clear:both"></div>
					
				</div>
				<div class="textBox">
					<!-- <p class="nav">
						<a href="javascript:;">首页</a> - <a href="javascript:;">关于我们</a> - <a
							href="javascript:;">帮助中心</a> - <a href="javascript:;">联系我们</a> <a href="javascript:;">-
							侵权申诉</a>
					</p> -->
				
					<div class="add">
						<p>地址：山东省菏泽市牡丹区皇家学府12楼</p>
					</div>
					<div class="webInfo">
						<p>
							<a href="javascript:;">鲁ICP备2020045846号-2</a>
						</p>
						<p>
						</p>
					</div>
				 
				</div>
				</div>
				<div class="codeBox">
					<p><img src="../assets/picture/7eabf5f89edd0cfe678e17a4d88fc0ee.jpg" alt=""></p>
					<h3>使用微信扫一扫</h3>
					
				</div>
				
			</div>
		</div>
	</div>
	<!--底部 end-->
</template>

<script>
	export default {
		name: 'Footer',

	}
</script>
 

<style>
	.footer .botInfoBox .textBox .webInfo a {
		font-size: 14px;
		color: #fff;
	}
	.footer {
		background: #282828;
		padding: 36px 0;
	}

	.footer .linkBox {
		height: 36px;
		padding: 24px 0;
		border-bottom: 1px solid #525252;
	}

	.footer .linkBox .linkLogo {
		width: 117px;
		height: 36px;
		border-right: 1px dashed #3e3e3e;
		background-position: -175px -100px;
	}

	.footer .linkBox .linkList {
		width: 1000px;
		height: 30px;
		overflow: hidden;
	}

	.footer .linkBox .linkList a {
		font-size: 15px;
		color: #ffffff;
		margin-left: 20px;
		line-height: 36px;
		white-space: nowrap;
	}

	.footer .botInfoBox {
		display: flex;
		justify-content:space-around;
		padding-top: 45px;
	}

	.footer .botInfoBox .textBox {
		width: 370px;
		height: 160px;
	}

	.footer .botInfoBox .textBox .nav {
		font-size: 18px;
		color: #fff;
	}

	.footer .botInfoBox .textBox .nav a {
		font-size: 18px;
		color: #ffffff;
	}

	.footer .botInfoBox .textBox .add {
		padding-top: 15px;
		font-size: 15px;
		color: #fff;
		opacity: .3;
		line-height: 1.6em;
	}

	.footer .botInfoBox .textBox .webInfo {
		padding-top: 15px;
		font-size: 15px;
		color: #fff;
		opacity: .3;
		line-height: 1.6em;
	}

	.footer .botInfoBox .textBox .webInfo a {
		font-size: 15px;
		color: #fff;
	}

	.footer .botInfoBox .phone {
	/* 	padding-top: 44px;
		height: 44px; */
		 
	}

	.footer .botInfoBox .phone .icon {
		float: left;
	}

	.footer .botInfoBox .phone .icon i {
		display: inline-block;
		width: 44px;
		height: 44px;
		background-position: -10px -145px;
	}

	.footer .botInfoBox .phone .phoneNum {
		float: left;
		margin-left: 5px;
	}

	.footer .botInfoBox .phone .phoneNum h3 {
		font-size: 14px;
		color: #fff;
		margin-top: -8px;
	}

	.footer .botInfoBox .phone .phoneNum p {
		font-size: 28px;
		color: #ffffff;
	}

	.footer .botInfoBox .codeBox {
		text-align: center;
	}

	.footer .botInfoBox .codeBox img {
		width: 98px;
		height: 98px;
	}

	.footer .botInfoBox .codeBox h3 {
		font-size: 14px;
		color: #fff;
		opacity: .3;
		padding-top: 12px;
	}
</style>
